import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import AppData from '../common/AppData'

import UserName from './UserName'

export default function HistoryOrders({ order , handleModalOpen }) {

    const [opacity, setOpacity] = useState('none')

    //rendering total quantity
    const totalQuantity = order => {
        let total = order.items
            .map(item => {
                if (item.price <= 0 || item.ProductType) {
                    return 0
                }
                return item.quantity
            })
            .reduce((previouVal, currentVal) => {
                return previouVal + currentVal
            }, 0)
        return total
    }

    //rendering total amount
    const totalAmount = order => {
        let grandTotal = '$' + (order.total / 100).toFixed(2).toString()
        return grandTotal
    }

    //rendering time
    const getTime = order => {
        const time = moment.utc(order.created).tz(AppData.hawaiiTimeZone).format('hh:mm A')
        return time
    }

    //Open Modal
    const modalOpen = () => {
        handleModalOpen(order)
    }

    // reset opacity
    const resetOpacity = () => {
        setOpacity(0.5)
        setTimeout(()=>{
            setOpacity(1)
        }, 100)
    }

    return (
        <div className="row-container" style={{opacity:`${opacity}`}} onTouchStart={resetOpacity} onClick={modalOpen}>
            <div className="transaction-details-wrapper">
                <Fragment>
                    <div className="headers">
                        <div className="time-value">{ getTime(order)}</div>
                    </div>
                    <div className="headers">
                        <UserName userProfile={order.user_profile} />
                    </div>
                </Fragment>
                <div className="headers">
                    <div className="qty">
                        {totalQuantity(order)}
                    </div>
                </div>
                <div className="headers">
                    <div className="total-price">
                        {totalAmount(order)}
                    </div>
                </div>
            </div>
        </div>
    )
}

HistoryOrders.propTypes = {
    handleModalOpen : PropTypes.func,
    order: PropTypes.object
}